const rule = () => ({
    margin: '5rem 2.5rem',
    textAlign: 'center',
    '& img': {
        display: 'block',
        width: '10rem',
        margin: 'auto',
        borderRadius: '16px',
    },
});

export default rule;
